import * as XLSX from 'xlsx'

export const USD_PER_TWO_MILLION_UNITS = 1110
export const USD_PER_EUR = 1.1204 // ECB reference rate, 5 October 2026

export const UNITS_PER_LINE = {
  'semrush-phrase-these': 10,
  'semrush-related-keywords': 40,
  'semrush-broad-match-keyword': 20,
  'semrush-phrase-questions': 40,
}

export const estimateSemrushCost = (keywords, endpoint, displayLimit) => {
  const keywordCount = new Set(keywords).size
  const rowsPerKeyword = endpoint === 'semrush-phrase-these' ? 1 : Number(displayLimit)
  const unitsPerLine = UNITS_PER_LINE[endpoint]

  if (!keywordCount || !unitsPerLine || !Number.isInteger(rowsPerKeyword) || rowsPerKeyword < 1) {
    return null
  }

  const units = keywordCount * rowsPerKeyword * unitsPerLine
  return { keywordCount, units, euros: (units * USD_PER_TWO_MILLION_UNITS) / 2000000 / USD_PER_EUR }
}

export const readSemrushKeywords = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      try {
        const workbook = XLSX.read(event.target.result, { type: 'array' })
        const rows = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
          header: 1,
          defval: '',
        })
        const keywordIndex = (rows[0] || []).indexOf('Keyword')
        if (keywordIndex < 0) {
          throw new Error('Il file deve contenere una colonna chiamata esattamente "Keyword".')
        }
        resolve(
          Array.from(
            new Set(
              rows
                .slice(1)
                .map((row) => String(row[keywordIndex] || '').trim())
                .filter(Boolean)
            )
          )
        )
      } catch (error) {
        reject(error)
      }
    }
    reader.onerror = () => reject(reader.error || new Error('Impossibile leggere il file.'))
    reader.readAsArrayBuffer(file)
  })
